import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class GlobalSettingsResolver implements Resolve<boolean> {
  constructor(
    private facade: FacadeService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>(async (res, rej) => {
      const globalSettings = await this.facade.getGlobalSettings(environment.app_settings_version);
      globalSettings.filter(setting => setting.name && setting.value).forEach(setting => {
        const {name, value} = setting;
        this.facade.addStorageItem(name!, value!);
      });

      this.facade.globalSettingsLoaded.next(true);

      res(true);
    });
  }
}
